<script setup lang="ts">
  import { ref } from 'vue';
  import ElButton from '@/components/common/formElements/buttons/ElButton.vue';
  import { useI18n } from 'vue-i18n';
  import CustomerServiceContent from '@/components/common/CustomerServiceContent/CustomerServiceContent.vue';
  import type { VueComponentPropsBase } from '@/types';
  import ElModal from '@/components/common/ElModal/ElModal.vue';

  type ComponentClasses = 'button';

  defineOptions({ name: 'CustomerServiceModal' });

  defineProps<Partial<VueComponentPropsBase<ComponentClasses>> & {
    /** Texte du lien */
    label: string;
  }>();

  const openModal = ref<boolean>(false);
  const { t } = useI18n();
</script>
<template>
  <div
    data-testid="customer-service-modal"
    class="inline-flex flex-row flex-wrap"
    :class="classes?.wrapper"
  >
    <ElButton
      :class="classes?.button"
      link
      @click="openModal = true"
    >
      {{ label }}
    </ElButton>
    <ElModal
      :open="openModal"
      @close="openModal = false"
    >
      <template #header>
        <h2>{{ t('contactUsPage.modalTitle') }}</h2>
      </template>
      <CustomerServiceContent :classes="{boxCardWrapper: 'md:rounded-none'}" />
      <div class="flex flex-col bg-page-background pt-8 pb-10 px-4">
        <ElButton
          primary
          class="md:self-center"
          @click="openModal = false"
        >
          {{ t('contactUsPage.modalCloseButton') }}
        </ElButton>
      </div>
    </ElModal>
  </div>
</template>
